import React, { useState } from "react";
import { articlesData } from "../../../blog/articlesData";
import ArticleCard from "../../../blog/articleCard";
import "./blogSection.css";
import { useNavigate } from "react-router-dom";

// need to make responsive

const BlogSectionClient = () => {
  const filteredArticles = articlesData;
  const navigate = useNavigate;
  return (
    <div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "200px",
          paddingBottom: "200px",
          flexDirection: "column",
        }}
      > */}
      <div className="blog-section-wrapper">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "95%",
            marginBottom: "30px",
          }}
        >
          <p className="blog-section-heading">Join the Legal Community</p>
          <p className="blog-section-community">Go to Community</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "40px",
            marginBottom: "20px",
            alignSelf: "flex-start",
            marginLeft: "2.5%",
            width: "95%",
          }}
        >
          <p className="blog-section-title">Legal Posts</p>
          <p
            className="blog-section-view-all"
            onClick={() => {
              navigate("/blog");
            }}
          >
            View all
          </p>
        </div>

        <div className="article-grid-client-new">
          {filteredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSectionClient;
